import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { useSensitiveInfoInputContext } from '../../../Context';
import LockedInputAdornment from './LockedInputAdornment';
import LockedInputEditAdornment from './LockedInputEditAdornment';

const LockedInputAdornmentPicker = (props) => {
  const { resource, relationshipName, writeOnly } = useSensitiveInfoInputContext();

  return pickFunction(resource, {
    [relationshipName]: () => {
      if (writeOnly) {
        return (
          <LockedInputEditAdornment {...props} />
        );
      }

      return (
        <LockedInputAdornment {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default LockedInputAdornmentPicker;
